import config from 'config'

export function tabs({ isIac = false, isLabelsEnabled = false } = {}) {
  return [
    {
      id: 1,
      label: 'Organization detail',
      intlKey: 'tabs.organization_detail',
      path: '/detail'
    },
    {
      id: 2,
      label: 'Contacts',
      intlKey: 'tabs.contacts',
      path: '/contacts'
    },
    {
      id: 3,
      label: 'Payment',
      intlKey: 'tabs.payment',
      path: '/payment',
      visibility: isIac ? 'hidden' : 'visible'
    },
    {
      id: 4,
      label: 'Labels',
      intlKey: 'tabs.labels',
      path: '/labels',
      visibility: !isLabelsEnabled ? 'hidden' : 'visible'
    }
  ]
}

export const root = `${config.publicPath}/my-organization`

export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email'
  },
  {
    id: 5,
    label: 'Award Unit',
    intlKey: 'table.award_unit'
  },
  {
    id: 6,
    label: 'Level',
    intlKey: 'table.level'
  },
  {
    id: 7,
    label: 'Progress',
    intlKey: 'table.progress'
  },
  {
    id: 8,
    label: 'Last Activity',
    intlKey: 'table.last_activity'
  },
  {
    id: 9,
    label: 'Status',
    intlKey: 'table.status'
  }
]

export const tableHeaderContacts = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email'
  }
  // {
  //   id: 5,
  //   label: 'Participants',
  //   intlKey: 'table.participants'
  // },
  // {
  //   id: 6,
  //   label: 'Status',
  //   intlKey: 'table.status'
  // }
]
